/**
 * Uppy's maxFileSize restriction runs at file-add time — before our uploader
 * ever calls normalizeOriginalForUpload. Only the direct-staging uploader
 * normalizes (decode EXIF-upright -> downscale to NORMALIZE_MAX_LONG_EDGE ->
 * JPEG) before the PUT, so it is the only path that can safely accept a camera
 * original; every other path puts the raw file on the wire and must stay at the
 * API's MAX_STAGING_UPLOAD_BYTES.
 *
 * Keep this in lockstep with the `useStaging && useDirect` branch of
 * createUppyInstance. Gating tighter than the normalize path (the original bug)
 * rejects photos the pipeline would have handled — modern Android cameras
 * routinely clear 10MB. Gating looser than it lets a raw oversized file reach
 * the wire, where the API rejects it with a 413.
 */

/** Direct-staging path: normalize shrinks whatever arrives, so admit originals. */
export const STAGING_MAX_FILE_SIZE = 50 * 1024 * 1024;

/** Legacy multipart + Cloudinary: the raw file goes on the wire as-is. */
export const RAW_UPLOAD_MAX_FILE_SIZE = 10 * 1024 * 1024;

export const resolveMaxFileSize = ({ useStaging, useDirect }) =>
  useStaging && useDirect ? STAGING_MAX_FILE_SIZE : RAW_UPLOAD_MAX_FILE_SIZE;
